import { render, staticRenderFns } from "./MetricasRecomendacoes.vue?vue&type=template&id=270eaf9e"
import script from "./MetricasRecomendacoes.vue?vue&type=script&lang=js"
export * from "./MetricasRecomendacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports